import { render } from "./EventCard.vue?vue&type=template&id=4c73382f&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=4c73382f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c73382f"

export default script